import { UniversalAnalyticsForm } from './UniversalAnalytics'
import { WebhookForm } from './Webhook'

export const dataStreamForms = {
  'Universal Analytics': UniversalAnalyticsForm,
  'Webhook': WebhookForm
}
